// React
import { Fragment } from "react"

// Components
import { styles as stylePdf } from "components"

// Third-Party Libraries
import moment from "moment"
import { Document, Page, Text, View } from "@react-pdf/renderer"
import { jwtDecode } from "jwt-decode"

// Types
import type { LinkAccountType } from "../LinkAccount/types"

type AccountHeaderType = {
    Header: string,
    LinkAccount: Omit<LinkAccountType, "linked_account_id">[]
}

export function PdfLinkAccount(props: {
    dataList: LinkAccountType[],
    dataLinkAccount: AccountHeaderType[],
    title: string
}) {
    // Vars
    const date: string = moment().format("DD MMM YYYY")
    const userData: { company_name?: string } = jwtDecode(localStorage.getItem("token") ?? "")
    const { title } = props

    return (
        <Document>
            <Page size="A4" style={stylePdf.page}>
                <View
                    fixed
                    style={stylePdf.fixedTop}
                >
                    <Text style={stylePdf.title}>{title}</Text>
                    <Text style={stylePdf.date}>{userData.company_name}</Text>
                    <Text style={stylePdf.date}>Date: {date}</Text>
                </View>

                <TableCell
                    dataList={props.dataList}
                    dataLinkAccount={props.dataLinkAccount}
                />

                <View
                    fixed
                    style={stylePdf.fixed}
                >
                    <Text style={stylePdf.text}>{title} | {userData.company_name ?? "-"} | {date}</Text>

                    <Text
                        style={stylePdf.text}
                        render={({ pageNumber, totalPages }) => `Page ${pageNumber} of ${totalPages}`}
                    />
                </View>
            </Page>
        </Document>
    )
}


function TableCell(props: {
    dataList: LinkAccountType[],
    dataLinkAccount: AccountHeaderType[]
}) {
    const header = ["CODE", "DESCRIPTION", "NUMBER", "COA NAME"]

    return (
        <Fragment>
            {props.dataLinkAccount.map((i, key) => (
                <>
                    <View style={{ marginTop: 5 }}>
                        <Text style={[stylePdf.headerText, { fontSize: 10 }]}>{i.Header}</Text>
                    </View>
                    <View style={stylePdf.table} key={key}>

                        {/* Header */}
                        <View style={stylePdf.tableHeader}>
                            {header.map((col, index) => (
                                <View style={stylePdf.tableCol}>
                                    <Text
                                        style={[
                                            stylePdf.headerText,
                                            { fontSize: 9 }
                                        ]}
                                        key={index}
                                    >
                                        {col}
                                    </Text>
                                </View>
                            ))}
                        </View>

                        {/* Data */}
                        {i.LinkAccount.map((sub, index) => {
                            const coa = props.dataList.find(list => list.linked_account_code === sub.linked_account_code)
                            return (
                                <>
                                    <View style={stylePdf.tableRow} key={index}>
                                        <View style={stylePdf.tableCol}>
                                            <Text style={[stylePdf.tableCell, { fontSize: 8 }]}>
                                                {sub.linked_account_code}
                                            </Text>
                                        </View>
                                        <View style={stylePdf.tableCol}>
                                            <Text style={[stylePdf.tableCell, { fontSize: 8 }]}>
                                                {sub.description}
                                            </Text>
                                        </View>
                                        <View style={stylePdf.tableCol}>
                                            <Text style={[stylePdf.tableCell, { fontSize: 8 }]}>
                                                {coa ? `${coa.coa_code}` : ''}
                                            </Text>
                                        </View>
                                        <View style={stylePdf.tableCol}>
                                            <Text style={[stylePdf.tableCell, { fontSize: 8 }]}>
                                                {coa?.coa_name}
                                            </Text>
                                        </View>
                                    </View>
                                </>
                            )
                        })}
                    </View>
                </>
            ))}

        </Fragment>
    )
}